(function($) {

  Drupal.behaviors.bfeed_bestsellers = {
    attach: function(context, settings) {

      // beauty feed carousel
      $('.beauty-feed-tout--bestseller-products__list .clearfix').slick({
        dots: true,
        arrows: true,
        infinite: true,
        slidesToShow: 1,
        autoplay: true,
        autoplaySpeed: 5000
      });

    } // attach
  };

})(jQuery);
